var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 35,
    stroke: "#081E56",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 102C77.8781 102 95.4353 87.7818 100.517 68.5M12 57C12 32.1472 32.1472 12 57 12C74.6686 12 89.9589 22.1828 97.3224 37",
    stroke: "#9EB25D",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 2C87.3757 2 112 26.6243 112 57C112 59.7172 111.803 62.3884 111.422 65M14.1636 22.5C6.55503 31.9351 2 43.9356 2 57C2 85.3482 23.4468 108.687 51 111.676",
    stroke: "#F1DB4B",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0283 66.0107H65.3877V74H57.4248V66.0107H40.9717V60.3418L57.873 35.4512H65.3877V59.6826H70.0283V66.0107ZM57.4248 59.6826V53.1436C57.4248 52.5283 57.4336 51.7988 57.4512 50.9551C57.4863 50.1113 57.5215 49.2676 57.5566 48.4238C57.5918 47.5801 57.627 46.833 57.6621 46.1826C57.7148 45.5146 57.75 45.0488 57.7676 44.7852H57.5566C57.2227 45.5059 56.8711 46.209 56.502 46.8945C56.1328 47.5625 55.7021 48.2656 55.21 49.0039L48.1436 59.6826H57.4248Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber4);
export default __webpack_public_path__ + "static/media/Number 4.927281f4bb4896f961c25605e30b3b44.svg";
export { ForwardRef as ReactComponent };